
import { Component, Prop, Vue } from '~/utility/pu-class-decorator'
import { SearchFilters } from '../../../apps/search/schemas'

@Component
export default class SearchSummaryBarDetails extends Vue {
  @Prop()
    searchFilters: SearchFilters

  @Prop({ required: false })
    slug?: string

  detailsScrolled = false
  detailsScrolledEnd = false

  get hasDates() {
    const dates = this.searchFilters.dates
    if (!dates || (!dates.arrive && !dates.depart)) return false
    return true
  }
  get isBoundsSearch(): boolean {
    return !!this.searchFilters.bounds
  }

  summaryBarFirstItemCallback(isVisible: boolean) {
    this.detailsScrolled = !isVisible
  }

  summaryBarLastItemCallback(isVisible: boolean) {
    this.detailsScrolledEnd = !isVisible
  }
}
